<template>
  <el-dialog
          :visible.sync="show"
          width="50%"
          title="添加签约规则"
          :before-close="closeDialog"
          :close-on-click-modal="false"
  >

    <el-form>

      <el-form-item
              label="说明:"
              label-width='120px'
      >
        <el-input
                v-model="submit_data.title"
                style="width: 80%"
        ></el-input>

      </el-form-item>



      <el-form-item
              label="状态:"
              label-width='120px'
      >
        <el-select
                v-model="submit_data.status"
                placeholder="请选择状态"
                style="width: 150px; margin-right: 20px;"
                clearable
        >
          <el-option
                  label="启用"
                  value="1"
          >
          </el-option>
          <el-option
                  label="禁用"
                  value="0"
          >
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item
              label="规则明细:"
              label-width='120px'
      >


        <el-button @click="addRules" type="text" style="float: right">+增加规则</el-button>



      </el-form-item>


      <el-table
              :data="tableData"
              style="width: 100%"
              ref="multipleTable"
              header-cell-class-name="table-header"
      >


        <el-table-column
                prop="day_array"
                label="规则天数(天)"
        >

          <template slot-scope="props">

            <el-input v-model="props.row.day_array" placeholder="请输入签约规则天数"></el-input>

          </template>


        </el-table-column>

        <el-table-column
                prop="driver_insurance_array"
                label="预付保险费(单)"
        >
          <template slot-scope="props">

            <el-input v-model="props.row.driver_insurance_array" placeholder="请输入当前天数预缴保险费多少单"></el-input>

          </template>

        </el-table-column>


        <el-table-column
                label="操作"
                width="80"
        >

          <template slot-scope="props">

            <el-button type="text" style="color: red" @click="del(props.row)">删除</el-button>

          </template>

        </el-table-column>

      </el-table>




      <!--      <el-form-item label-width='120px'>-->

      <!--        <el-button @click="addRules">增加规则</el-button>-->

      <!--      </el-form-item>-->

    </el-form>
    <span
            slot="footer"
            class="dialog-footer"
    >
      <el-button @click="closeDialog">取 消</el-button>
      <!--      <el-button-->
      <!--        type="primary"-->
      <!--        @click="onSubmit"-->
      <!--      >确 定</el-button>-->
      <submitBtn @onSubmitDig="onSubmitDig" @toJSON="toJSON" :data="submit_data" :rules="submit_rules" :url="submit_url" :JSON_Boolean="true"></submitBtn>
    </span>
  </el-dialog>
</template>

<script>
  var _this;
  export default {
    props: {
      isShow: Boolean,
      data: ''
    },
    watch: {
      isShow(newData, oldData) {
        _this.show = true;
        _this.submit_data.driver_signing_day_code = _this.data;

        _this.$post('/driver/getDriverSigningDayDetails', {
          driver_signing_day_code:_this.data
        }).then((res) => {

          _this.submit_data.title = res.data.title;
          _this.submit_data.status = res.data.status.val;

          let objLength = '';

          // 判断day_array和driver_insurance_array哪个长度更长
          if(JSON.parse(res.data.day_array).length >= JSON.parse(res.data.driver_insurance_array).length){
            objLength = JSON.parse(res.data.day_array).length
          }else {
            objLength = JSON.parse(res.data.driver_insurance_array).length
          }

          for (let i=0; i<objLength;i++){
            _this.tableData.push({
              day_array:'',
              driver_insurance_array:''
            });
          }



          if (res.data.day_array !== ''){

            _this.submit_data.day_array= JSON.parse(res.data.day_array);





            for (var i=0;i<JSON.parse(res.data.day_array).length;i++){





              _this.tableData[i].day_array = JSON.parse(res.data.day_array)[i]


              console.log(_this.tableData);

            }

          }

          if(JSON.parse(res.data.driver_insurance_array) !== ''){

            _this.submit_data.driver_insurance_array= JSON.parse(res.data.driver_insurance_array);

            for (var i=0;i<JSON.parse(res.data.driver_insurance_array).length;i++){

              _this.tableData[i].driver_insurance_array = JSON.parse(res.data.driver_insurance_array)[i]

            }

          }






        })
        .catch((res) => {});
      }
    },
    data() {
      return {
        show: false,


        submit_url:'/driver/editDriverSigningDaySubmit',
        // 表单数据
        submit_data: {
          title: '',
          day_array: '',
          status: '',
          driver_insurance_array:''
        },

        // 表格数据
        tableData:[],



        submit_rules: {


          status: {
            placeholder: '状态',
            rules: {
              required: true,
              message: '状态错误',
              regulation: 'special',
              rulesData: '0|1'
            }
          }
        }
      };
    },
    created() {
      _this = this;
    },
    methods: {
      del(obj) {

        // 获取对应下标
        var index = _this.tableData.indexOf(obj);

        this.tableData.splice(index, 1);

      },

      addRules() {
        this.tableData.push({
          day_array:'',
          driver_insurance_array:''
        });
      },

      // 关闭方法
      closeDialog() {
        _this.show = false;
        _this.submit_data = {
          title: '',
          day_array: '',
          status: '',
          driver_insurance_array:''
        };
        _this.tableData = []
      },
      toJSON(){
        var day_array = [];
        var driver_insurance_array = [];

        for (var i = 0;i < _this.tableData.length;i++){

          day_array.push(_this.tableData[i].day_array);

          driver_insurance_array.push(_this.tableData[i].driver_insurance_array);


        }

        _this.submit_data.day_array = JSON.stringify(day_array);
        _this.submit_data.driver_insurance_array = JSON.stringify(driver_insurance_array);


        console.log( _this.submit_data);

      },
      // 提交
      onSubmitDig() {

        // 触发父组件自定义事件刷新表格
        _this.$emit('onSubmit');
        _this.closeDialog();


      }
    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>